import { render, staticRenderFns } from "./liveVideo.vue?vue&type=template&id=2ab8a3e6&scoped=true&"
import script from "./liveVideo.vue?vue&type=script&lang=js&"
export * from "./liveVideo.vue?vue&type=script&lang=js&"
import style0 from "./liveVideo.vue?vue&type=style&index=0&id=2ab8a3e6&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "2ab8a3e6",
  null
  
)

export default component.exports